import {r as E} from '@theme/request-idle-callback';
import {C as w, h as A} from '@theme/combined-listings';
import '@theme/theme-sections';
import '@theme/product-video';
import '@theme/viewport-video';
import {initCartCarousel} from '@theme/cart-carousel';
function L(s) {
  return Array.from(
    s.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((s) => {
  s.setAttribute('role', 'button'),
    s.setAttribute('aria-expanded', 'false'),
    s.nextElementSibling.getAttribute('id') && s.setAttribute('aria-controls', s.nextElementSibling.id),
    s.addEventListener('click', (t) => {
      t.currentTarget.setAttribute('aria-expanded', !t.currentTarget.closest('details').hasAttribute('open'));
    }),
    !s.closest('header-drawer') && s.parentElement.addEventListener('keyup', T);
});
const l = {};
function d(s, t = s) {
  const e = L(s),
    i = e[0],
    n = e[e.length - 1];
  c(),
    (l.focusin = (o) => {
      (o.target !== s && o.target !== n && o.target !== i) || document.addEventListener('keydown', l.keydown);
    }),
    (l.focusout = function () {
      document.removeEventListener('keydown', l.keydown);
    }),
    (l.keydown = function (o) {
      o.code.toUpperCase() === 'TAB' &&
        (o.target === n && !o.shiftKey && (o.preventDefault(), i.focus()),
        (o.target === s || o.target === i) && o.shiftKey && (o.preventDefault(), n.focus()));
    }),
    document.addEventListener('focusout', l.focusout),
    document.addEventListener('focusin', l.focusin),
    t.focus();
}
try {
  document.querySelector(':focus-visible');
} catch {
  C();
}
function C() {
  const s = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let t = null,
    e = null;
  window.addEventListener('keydown', (i) => {
    s.includes(i.code.toUpperCase()) && (e = !1);
  }),
    window.addEventListener('mousedown', (i) => {
      e = !0;
    }),
    window.addEventListener(
      'focus',
      () => {
        t && t.classList.remove('focused'), !e && ((t = document.activeElement), t.classList.add('focused'));
      },
      !0
    );
}
function c(s = null) {
  document.removeEventListener('focusin', l.focusin),
    document.removeEventListener('focusout', l.focusout),
    document.removeEventListener('keydown', l.keydown),
    s && s.focus();
}
function T(s) {
  if (s.code.toUpperCase() !== 'ESCAPE') return;
  const t = s.target.closest('details[open]');
  if (!t) return;
  const e = t.querySelector('summary');
  t.removeAttribute('open'), e.setAttribute('aria-expanded', !1), e.focus();
}
class P extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input')),
      (this.changeEvent = new Event('change', {bubbles: !0})),
      this.querySelectorAll('button').forEach((t) => t.addEventListener('click', this.onButtonClick.bind(this)));
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = this.input.value;
    t.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown(),
      e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', P);
function $(s, t) {
  let e;
  return (...i) => {
    clearTimeout(e), (e = setTimeout(() => s.apply(this, i), t));
  };
}
function H(s = 'json') {
  return {method: 'POST', headers: {'Content-Type': 'application/json', Accept: `application/${s}`}};
}
typeof window.Shopify > 'u' && (window.Shopify = {});
Shopify.bind = function (s, t) {
  return function () {
    return s.apply(t, arguments);
  };
};
Shopify.setSelectorByValue = function (s, t) {
  for (let e = 0, i = s.options.length; e < i; e++) {
    const n = s.options[e];
    if (t == n.value || t == n.innerHTML) return (s.selectedIndex = e), e;
  }
};
Shopify.addListener = function (s, t, e) {
  s.addEventListener ? s.addEventListener(t, e, !1) : s.attachEvent(`on${t}`, e);
};
Shopify.postLink = function (s, t) {
  t = t || {};
  const e = t.method || 'post',
    i = t.parameters || {},
    n = document.createElement('form');
  n.setAttribute('method', e), n.setAttribute('action', s);
  for (const o in i) {
    const r = document.createElement('input');
    r.setAttribute('type', 'hidden'), r.setAttribute('name', o), r.setAttribute('value', i[o]), n.appendChild(r);
  }
  document.body.appendChild(n), n.submit(), document.body.removeChild(n);
};
Shopify.CountryProvinceSelector = function (s, t, e) {
  (this.countryEl = document.getElementById(s)),
    (this.provinceEl = document.getElementById(t)),
    (this.provinceContainer = document.getElementById(e.hideElement || t)),
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this)),
    this.initCountry(),
    this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const s = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, s), this.countryHandler();
  },
  initProvince() {
    const s = this.provinceEl.getAttribute('data-default');
    s && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, s);
  },
  countryHandler(s) {
    var t = this.countryEl.options[this.countryEl.selectedIndex];
    const e = t.getAttribute('data-provinces'),
      i = JSON.parse(e);
    if ((this.clearOptions(this.provinceEl), i && i.length == 0)) this.provinceContainer.style.display = 'none';
    else {
      for (let n = 0; n < i.length; n++) {
        var t = document.createElement('option');
        (t.value = i[n][0]), (t.innerHTML = i[n][1]), this.provinceEl.appendChild(t);
      }
      this.provinceContainer.style.display = '';
    }
  },
  clearOptions(s) {
    for (; s.firstChild; ) s.removeChild(s.firstChild);
  },
  setOptions(s, t) {
    for (let e = 0, i = t.length; e < t.length; e++) {
      const n = document.createElement('option');
      (n.value = t[e]), (n.innerHTML = t[e]), s.appendChild(n);
    }
  },
};
class y extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector('details')),
      navigator.platform === 'iPhone' &&
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`),
      this.addEventListener('keyup', this.onKeyUp.bind(this)),
      this.addEventListener('focusout', this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach((t) => t.addEventListener('click', this.onSummaryClick.bind(this))),
      this.querySelectorAll('button').forEach((t) => {
        t.classList.contains('localization-form__select') ||
          t.addEventListener('click', this.onCloseButtonClick.bind(this));
      });
  }
  onKeyUp(t) {
    if (t.code.toUpperCase() !== 'ESCAPE') return;
    const e = t.target.closest('details[open]');
    e &&
      (e === this.mainDetailsToggle
        ? this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector('summary'))
        : this.closeSubmenu(e));
  }
  onSummaryClick(t) {
    const e = t.currentTarget,
      i = e.parentNode,
      n = i.hasAttribute('open'),
      o = window.matchMedia('(prefers-reduced-motion: reduce)');
    function r() {
      d(e.nextElementSibling, i.querySelector('button')), e.nextElementSibling.removeEventListener('transitionend', r);
    }
    i === this.mainDetailsToggle
      ? (n && t.preventDefault(), n ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e))
      : setTimeout(() => {
          i.classList.add('menu-opening'),
            e.setAttribute('aria-expanded', !0),
            !o || o.matches ? r() : e.nextElementSibling.addEventListener('transitionend', r);
        }, 100);
  }
  openMenuDrawer(t) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    }),
      t.setAttribute('aria-expanded', !0),
      d(this.mainDetailsToggle, t),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(t, e = !1) {
    this.mainDetailsToggle.classList.remove('menu-opening'),
      this.mainDetailsToggle.querySelectorAll('details').forEach((i) => {
        i.removeAttribute('open'), i.classList.remove('menu-opening');
      }),
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
      c(e),
      this.closeAnimation(this.mainDetailsToggle);
  }
  onFocusOut(t) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        !this.classList.contains('disclosure__button') &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(t) {
    const e = t.currentTarget.closest('details');
    this.closeSubmenu(e);
  }
  closeSubmenu(t) {
    t.classList.remove('menu-opening'),
      t.querySelector('summary').setAttribute('aria-expanded', !1),
      c(t.querySelector('summary')),
      this.closeAnimation(t);
  }
  closeAnimation(t) {
    let e;
    const i = (n) => {
      e === void 0 && (e = n),
        n - e < 400
          ? window.requestAnimationFrame(i)
          : (t.removeAttribute('open'),
            t.closest('details[open]') && d(t.closest('details[open]'), t.querySelector('summary')));
    };
    window.requestAnimationFrame(i);
  }
}
customElements.define('menu-drawer', y);
class B extends y {
  constructor() {
    super();
  }
  openMenuDrawer(t) {
    (this.header = this.header || document.getElementById('shopify-section-header')),
      (this.borderOffset =
        this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      ),
      this.header.classList.add('menu-open'),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      }),
      t.setAttribute('aria-expanded', !0),
      d(this.mainDetailsToggle, t),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(t, e) {
    super.closeMenuDrawer(t, e), this.header.classList.remove('menu-open');
  }
}
customElements.define('header-drawer', B);

function pauseManagedMedia() {
  window.pauseAllMedia?.();
  document.querySelectorAll('viewport-video[data-interactive]').forEach(player => player.requestPause?.());
}

class q extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this)),
      this.addEventListener('keyup', (t) => {
        t.code.toUpperCase() === 'ESCAPE' && this.hide();
      }),
      this.classList.contains('media-modal')
        ? this.addEventListener('pointerup', (t) => {
            t.pointerType === 'mouse' && !t.target.closest('deferred-media, product-model') && this.hide();
          })
        : this.addEventListener('click', (t) => {
            t.target.nodeName === 'MODAL-DIALOG' && this.hide();
          });
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(t) {
    this.openedBy = t;
    const e = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden'),
      this.setAttribute('open', ''),
      pauseManagedMedia(),
      e && e.loadContent(),
      d(this, this.querySelector('[role="dialog"]'));
  }
  hide() {
    document.body.classList.remove('overflow-hidden'),
      this.removeAttribute('open'),
      c(this.openedBy),
      pauseManagedMedia();
  }
}
customElements.get('modal-dialog') || customElements.define('modal-dialog', q);
class I extends HTMLElement {
  constructor() {
    super();
    const t = this.querySelector('button');
    t &&
      t.addEventListener('click', () => {
        const e = document.querySelector(this.getAttribute('data-modal'));
        e && e.show(t);
      });
  }
}
customElements.get('modal-opener') || customElements.define('modal-opener', I);
class x extends HTMLElement {
  constructor() {
    super();
    const t = this.querySelector('[id^="Deferred-Poster-"]');
    t && t.addEventListener('click', this.loadContent.bind(this));
  }
  loadContent(focus = true) {
    pauseManagedMedia();
    if (!this.hasAttribute('loaded')) {
      // hosted-video also emits a module tag and a no-JS fallback. Select the
      // player from the entire fragment and retain its source-owning wrapper.
      const fragment = this.querySelector('template')?.content.cloneNode(true);
      const media = fragment?.querySelector('viewport-video, video, model-viewer, iframe');
      if (!media) return;
      this.appendChild(media);
      this.setAttribute('loaded', '');
    }
    const player = this.querySelector(':scope > viewport-video');
    const media = player?.querySelector('video') || this.querySelector(':scope > video, :scope > model-viewer, :scope > iframe');
    if (focus) media?.focus();
    if (player) player.requestPlay().catch(() => { /* Native controls remain available after blocked playback. */ });
  }
}
customElements.get('deferred-media') || customElements.define('deferred-media', x);
class g extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector('.slider-counter--current')),
      (this.pageTotalElement = this.querySelector('.slider-counter--total')),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      !this.slider || !this.nextButton)
    )
      return;
    this.initPages(),
      new ResizeObserver((e) => this.initPages()).observe(this.slider),
      this.slider.addEventListener('scroll', this.update.bind(this)),
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this)),
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }
  initPages() {
    (this.sliderItemsToShow = Array.from(this.sliderItems).filter((t) => t.clientWidth > 0)),
      (this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1]),
      this.sliderItemsToShow.length !== 0 &&
        ((this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth)),
        (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update());
  }
  resetPages() {
    (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages();
  }
  update() {
    const t = this.currentPage;
    (this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != t &&
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1]},
          })
        ),
      !this.enableSliderLooping &&
        (this.isSlideVisible(this.sliderItemsToShow[0])
          ? this.prevButton.setAttribute('disabled', 'disabled')
          : this.prevButton.removeAttribute('disabled'),
        this.isSlideVisible(this.sliderLastItem)
          ? this.nextButton.setAttribute('disabled', 'disabled')
          : this.nextButton.removeAttribute('disabled'));
  }
  isSlideVisible(t, e = 0) {
    const i = this.slider.clientWidth + this.slider.scrollLeft - e;
    return t.offsetLeft + t.clientWidth <= i && t.offsetLeft >= this.slider.scrollLeft;
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = t.currentTarget.dataset.step || 1;
    (this.slideScrollPosition =
      t.currentTarget.name === 'next'
        ? this.slider.scrollLeft + e * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - e * this.sliderLastItem.clientWidth),
      this.slider.scrollTo({left: this.slideScrollPosition});
  }
}
customElements.get('slider-component') || customElements.define('slider-component', g);
class k extends g {
  constructor() {
    super(),
      (this.sliderControlWrapper = this.querySelector('.slider-buttons')),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
        ((this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
        )),
        this.sliderControlLinksArray.forEach((t) => t.addEventListener('click', this.linkToSlide.bind(this))),
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this)),
        this.setSlideVisibility(),
        this.slider.getAttribute('data-autoplay') === 'true' && this.setAutoPlay());
  }
  setAutoPlay() {
    (this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')),
      (this.autoplaySpeed = this.slider.dataset.speed * 1e3),
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this)),
      this.addEventListener('mouseover', this.focusInHandling.bind(this)),
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this)),
      this.addEventListener('focusin', this.focusInHandling.bind(this)),
      this.addEventListener('focusout', this.focusOutHandling.bind(this)),
      this.play(),
      (this.autoplayButtonIsSetToPlay = !0);
  }
  onButtonClick(t) {
    super.onButtonClick(t);
    const e = this.currentPage === 1,
      i = this.currentPage === this.sliderItemsToShow.length;
    (!e && !i) ||
      (e && t.currentTarget.name === 'previous'
        ? (this.slideScrollPosition =
            this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
        : i && t.currentTarget.name === 'next' && (this.slideScrollPosition = 0),
      this.slider.scrollTo({left: this.slideScrollPosition}));
  }
  update() {
    super.update(),
      (this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')),
      this.prevButton.removeAttribute('disabled'),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((t) => {
          t.classList.remove('slider-counter__link--active'), t.removeAttribute('aria-current');
        }),
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active'),
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', !0));
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
  }
  focusOutHandling(t) {
    const e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
    !this.autoplayButtonIsSetToPlay || e || this.play();
  }
  focusInHandling(t) {
    (t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target)) &&
    this.autoplayButtonIsSetToPlay
      ? this.play()
      : this.autoplayButtonIsSetToPlay && this.pause();
  }
  play() {
    this.slider.setAttribute('aria-live', 'off'),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed));
  }
  pause() {
    this.slider.setAttribute('aria-live', 'polite'), clearInterval(this.autoplay);
  }
  togglePlayButtonState(t) {
    t
      ? (this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused'),
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow))
      : (this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused'),
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow));
  }
  autoRotateSlides() {
    const t =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({left: t});
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((t, e) => {
      const i = t.querySelector('a');
      e === this.currentPage - 1
        ? (i && i.removeAttribute('tabindex'), t.setAttribute('aria-hidden', 'false'), t.removeAttribute('tabindex'))
        : (i && i.setAttribute('tabindex', '-1'),
          t.setAttribute('aria-hidden', 'true'),
          t.setAttribute('tabindex', '-1'));
    });
  }
  linkToSlide(t) {
    t.preventDefault();
    const e =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({left: e});
  }
}
customElements.get('slideshow-component') || customElements.define('slideshow-component', k);
class b extends HTMLElement {
  constructor() {
    super(), (this.combinedListings = new w(this)), this.addEventListener('change', this.onVariantChange);
  }
  disconnectedCallback() {
    this.combinedListings.destroy();
  }
  connectedCallback() {
    this.getAttribute('data-select-first') === 'true' && !A(this) && E(this.onVariantChange.bind(this));
  }
  onVariantChange(t) {
    this.combinedListings.handleChange(t) ||
      (this.updateOptions(),
      this.updateOptionAvailability(),
      this.updateMasterId(),
      this.toggleAddButton(),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.renderProductInfo(),
      this.currentVariant
        ? (this.updateURL(), this.updateVariantInput(), this.updateShareUrl(), this.updateInventoryStatus())
        : (this.updatePartialVariant(), this.setUnavailable()));
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (t) => t.value);
  }
  updateOptionAvailability() {
    this.querySelectorAll('[data-option]').forEach((e) => {
      const i = this.options.map((o, r) => (r === Number(e.dataset.optionIndex) ? e.dataset.value : o)),
        n = this.getVariantByOptions(i);
      e.classList.toggle('option--hidden', !n), e.classList.toggle('option--disabled', n && !n.available);
    });
  }
  getVariantByOptions(t) {
    const e = t || this.options;
    return this.getVariantData().find((i) => i.options.every((n, o) => n === e[o]));
  }
  updateMasterId() {
    const t = this.getVariantByOptions();
    if (t) this.currentVariant = t;
    else if (this.selectFirst) {
      const e = Array.from(this.querySelectorAll('[data-option]')).find((o) => !o.classList.contains('option--hidden'));
      if (!e) return;
      const i = e.querySelector('input[type="radio"]');
      i && (i.checked = !0);
      const n = this.options.map((o, r) => (r === Number(e.dataset.optionIndex) ? e.dataset.value : o));
      this.currentVariant = this.getVariantByOptions(n);
    }
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    document
      .getElementById(`MediaGallery-${this.dataset.section}`)
      .setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0);
    const e = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`),
      i = e.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    e.prepend(i);
  }
  updateURL() {
    !this.currentVariant ||
      this.dataset.updateUrl === 'false' ||
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateShareUrl() {
    const t = document.getElementById(`Share-${this.dataset.section}`);
    t && t.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateInventoryStatus() {
    var o, r;
    const t = document.querySelector(`product-form[data-form-id="product-form-${this.dataset.section}"]`);
    if (!t) return;
    const e = t.querySelector('[data-inventory-status]');
    if (!e) return;
    let i = '',
      n = '';
    if (this.currentVariant) {
      const a = window.theme.strings.products.variantSelect.optionNote,
        u = window.theme.settings.products.enableLowStockThreshold;
      this.currentVariant.available
        ? u &&
          (r = (o = this.currentVariant) == null ? void 0 : o.custom) != null &&
          r.is_low_stock &&
          ((i = a.fewRemaining.replace('{{ count }}', this.currentVariant.inventory_quantity)), (n = 'low-stock'))
        : ((i = a.soldOut), (n = 'sold-out'));
    }
    (e.textContent = i), (e.dataset.inventoryStatus = n);
  }
  getPartialVariant() {
    const t = Array.from(this.querySelectorAll('[data-option]')).find((i) => !i.classList.contains('option--hidden'));
    if (!t) return;
    const e = this.options.map((i, n) => (n === Number(t.dataset.optionIndex) ? t.dataset.value : i));
    return this.getVariantByOptions(e);
  }
  updatePartialVariant() {
    document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`).forEach((e) => {
      const i = e.querySelector('input[name="id"]'),
        n = this.getPartialVariant();
      (i.value = n.id),
        i.dispatchEvent(new Event('change', {bubbles: !0})),
        i.dispatchEvent(new CustomEvent('variant_update', {bubbles: !0, detail: {variant: n}}));
    });
  }
  updateVariantInput() {
    document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`).forEach((e) => {
      const i = e.querySelector('input[name="id"]');
      (i.value = this.currentVariant.id),
        i.dispatchEvent(new Event('change', {bubbles: !0})),
        i.dispatchEvent(new CustomEvent('variant_update', {bubbles: !0, detail: {variant: this.currentVariant}}));
    });
  }
  updatePickupAvailability() {
    const t = document.querySelector('pickup-availability');
    t &&
      (this.currentVariant && this.currentVariant.available
        ? t.fetchAvailability(this.currentVariant.id)
        : (t.removeAttribute('available'), (t.innerHTML = '')));
  }
  removeErrorMessage() {
    const t = this.closest('section');
    if (!t) return;
    const e = t.querySelector('product-form');
    e && e.handleErrorMessage();
  }
  renderProductInfo() {
    const t = this.currentVariant || this.getPartialVariant();
    t &&
      fetch(`${this.dataset.url}?variant=${t.id}&section_id=${this.dataset.section}`)
        .then((e) => e.text())
        .then((e) => {
          const i = `price-${this.dataset.section}`,
            n = new DOMParser().parseFromString(e, 'text/html'),
            o = document.getElementById(i),
            r = n.getElementById(i),
            a = document.querySelector('[data-product-form-selected-option-value]'),
            u = n.querySelector('[data-product-form-selected-option-value]');
          if (a && u) {
            const S = u.textContent;
            a.innerHTML = S;
          }
          r && o && (o.innerHTML = r.innerHTML);
          const p = document.getElementById(`price-${this.dataset.section}`);
          p && p.classList.remove('visibility-hidden');
        })
        .catch((e) => {
          window.console.error(e);
        });
  }
  toggleAddButton() {
    var n, o;
    const t = document.getElementById(`product-form-${this.dataset.section}`);
    if (!t) return;
    const e = t.querySelector('[name="add"]');
    if (!e) return;
    const i = t.querySelector('[name="add"] > span');
    if ((e.toggleAttribute('disabled', !this.currentVariant || !this.currentVariant.available), this.currentVariant))
      if (this.currentVariant.available) i.textContent = window.variantStrings.addToCart;
      else {
        const r = (o = this.closest('[data-section-type]')) == null ? void 0 : o.querySelector('[data-product-json]'),
          a = r ? JSON.parse(r.textContent) : null;
        a == null || a.is_archived, (i.textContent = window.variantStrings.soldOut);
      }
    else {
      const r = (n = this.closest('[data-section-type]')) == null ? void 0 : n.querySelector('[data-product-json]'),
        a = r ? JSON.parse(r.textContent) : null;
      (a == null ? void 0 : a.is_archived) === !0
        ? (i.textContent = window.variantStrings.soldOut)
        : (i.textContent = window.variantStrings.unavailable);
    }
  }
  setUnavailable() {
    const t = document.getElementById(`product-form-${this.dataset.section}`);
    if (!t || !t.querySelector('[name="add"]')) return;
    const i = t.querySelector('[name="add"] > span'),
      n = document.getElementById(`price-${this.dataset.section}`);
    (i.textContent = window.variantStrings.unavailable), n && n.classList.add('visibility-hidden');
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)),
      this.variantData
    );
  }
}
customElements.define('variant-selects', b);
class V extends b {
  constructor() {
    super();
  }
  updateOptions() {
    const t = Array.from(this.querySelectorAll('fieldset')),
      e = t
        ? t.map((o) => {
            var r;
            return (r = Array.from(o.querySelectorAll('input')).find((a) => a.checked)) == null ? void 0 : r.value;
          })
        : [],
      i = Array.from(this.querySelectorAll('select')),
      n = i ? i.map((o) => o.value) : [];
    this.options = [...e, ...n];
  }
}
customElements.get('variant-radios') || customElements.define('variant-radios', V);
let cartRecommendationRequest = 0;
let cartRecommendationController;
function v() {
  const request = ++cartRecommendationRequest;
  cartRecommendationController?.abort();
  cartRecommendationController = new AbortController();
  // Cart updates must not wait for recommendations.
  const overlay = document.querySelector('.cart-drawer .overlay');
  if (overlay) overlay.style.display = 'none';
  const s = [
    ...new Set(
      Array.from(document.querySelectorAll('.product-id-hidden'), (item) => item.getAttribute('idprd')).filter(Boolean)
    ),
  ];
  if (!s.length) {
    const container = document.querySelector('.product-recommendations-cart');
    if (container) container.style.display = 'none';
    return;
  }
  return f(s, request, cartRecommendationController.signal);
}
window.theme = window.theme || {};
window.theme.utils = {getRandomIdProduct: v};
// Re-select cards when the campaign starts or ends while the drawer stays open.
document.addEventListener('elk:spend-save-state-change', (event) => {
  if (event.target.matches('.spend-save-progress') && event.target.closest('.cart-drawer')) v();
});
async function f(s, request, signal) {
  const t = document.querySelector('.product-recommendations-cart');
  if (!t) return;
  const isCurrent = () => request === cartRecommendationRequest && t === document.querySelector('.product-recommendations-cart');
  const l = Math.min(10, Math.max(1, Number.parseInt(t.dataset.recommendationLimit, 10) || 8));
  function e() {
    return initCartCarousel(t, {
      loop: !1,
      margin: 12,
      nav: !0,
      navContainer: '.nav-owl-hehe',
      dots: !1,
      mouseDrag: !0,
      touchDrag: !0,
      pullDrag: !0,
      // Use width-based bounds so a fractional visible count can reach the last card.
      merge: !0,
      items: 2.5,
    }, isCurrent);
  }
  try {
    t.style.display = 'none';
    const promotion = document.querySelector('.cart-drawer .spend-save-progress');
    const curated = document.querySelector('.cart-drawer template[data-spend-save-recommendations]');
    if (promotion && !promotion.hidden && curated?.innerHTML.trim()) {
      // These cards use the same server-rendered cart as the progress panel.
      // They remain independent of Shopify's related-products API.
      t.innerHTML = curated.innerHTML;
      t.style.display = 'block';
      await e();
      return;
    }
    for (const productId of s) {
      const i = await fetch(
        `${window.Shopify.routes.root}recommendations/products?product_id=${productId}&limit=${l}&section_id=product-recommendations-cart&intent=related`,
        {signal}
      );
      if (!isCurrent()) return;
      // Old cart lines can refer to products no longer published on the online store.
      if (i.status === 404) continue;
      if (!i.ok) throw new Error(`Failed to get product recommendations. ${i.status} - ${i.statusText}`);
      const n = document.createElement('div');
      const markup = await i.text();
      if (!isCurrent()) return;
      n.innerHTML = markup;
      const o = n.querySelector('.product-recommendations');
      if (o?.querySelector('.cart-upsell__item')) {
        t.innerHTML = o.innerHTML;
        t.style.display = 'block';
        await e();
      } else {
        t.style.display = 'none';
      }
      return;
    }
    t.style.display = 'none';
  } catch (i) {
    if (i.name === 'AbortError' || !isCurrent()) return;
    window.console.error(i);
    t.style.display = 'none';
  }
}
export {x as D, q as M, $ as d, H as f, v as g, T as o, c as r, d as t};
